import React from 'react';

const IconMarginTrading = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.3333 12.1667C19.8166 12.1667 20.2083 12.5584 20.2083 13.0417V14.875C20.2083 15.3582 19.8166 15.75 19.3333 15.75C18.8501 15.75 18.4583 15.3582 18.4583 14.875V13.0417C18.4583 12.5584 18.8501 12.1667 19.3333 12.1667Z"
      fill="#06090D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66667 15.8333C5.14992 15.8333 5.54167 16.2251 5.54167 16.7083V18.5417C5.54167 19.0249 5.14992 19.4167 4.66667 19.4167C4.18342 19.4167 3.79167 19.0249 3.79167 18.5417V16.7083C3.79167 16.2251 4.18342 15.8333 4.66667 15.8333Z"
      fill="#06090D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 16.75C12.4832 16.75 12.875 17.1418 12.875 17.625V20.375C12.875 20.8582 12.4832 21.25 12 21.25C11.5168 21.25 11.125 20.8582 11.125 20.375V17.625C11.125 17.1418 11.5168 16.75 12 16.75Z"
      fill="#06090D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.3333 4.83333C19.8166 4.83333 20.2083 5.22508 20.2083 5.70833V7.54167C20.2083 8.02492 19.8166 8.41667 19.3333 8.41667C18.8501 8.41667 18.4583 8.02492 18.4583 7.54167V5.70833C18.4583 5.22508 18.8501 4.83333 19.3333 4.83333Z"
      fill="#06090D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66667 8.5C5.14992 8.5 5.54167 8.89175 5.54167 9.375V11.2083C5.54167 11.6916 5.14992 12.0833 4.66667 12.0833C4.18342 12.0833 3.79167 11.6916 3.79167 11.2083V9.375C3.79167 8.89175 4.18342 8.5 4.66667 8.5Z"
      fill="#06090D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3C12.4832 3 12.875 3.39175 12.875 3.875V6.625C12.875 7.10825 12.4832 7.5 12 7.5C11.5168 7.5 11.125 7.10825 11.125 6.625V3.875C11.125 3.39175 11.5168 3 12 3Z"
      fill="#06090D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6667 8.45833C16.6667 7.49184 17.4502 6.70833 18.4167 6.70833H20.25C21.2165 6.70833 22 7.49184 22 8.45833V12.125C22 13.0915 21.2165 13.875 20.25 13.875H18.4167C17.4502 13.875 16.6667 13.0915 16.6667 12.125V8.45833ZM18.4167 8.45833V12.125H20.25V8.45833H18.4167Z"
      fill="#06090D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12.125C2 11.1585 2.7835 10.375 3.75 10.375H5.58333C6.54983 10.375 7.33333 11.1585 7.33333 12.125V15.7917C7.33333 16.7582 6.54983 17.5417 5.58333 17.5417H3.75C2.7835 17.5417 2 16.7582 2 15.7917V12.125ZM3.75 12.125V15.7917H5.58333V12.125H3.75Z"
      fill="#06090D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.33333 7.54167C9.33333 6.57517 10.1168 5.79167 11.0833 5.79167H12.9167C13.8832 5.79167 14.6667 6.57517 14.6667 7.54167V16.7083C14.6667 17.6748 13.8832 18.4583 12.9167 18.4583H11.0833C10.1168 18.4583 9.33333 17.6748 9.33333 16.7083V7.54167ZM11.0833 7.54167V16.7083H12.9167V7.54167H11.0833Z"
      fill="#06090D"
    />
  </svg>
);

export default IconMarginTrading;
